module.exports = __webpack_public_path__ + "static/media/Lincoln.c2d052f5.png";